/* eslint-disable */
import { useState, useEffect } from "react";
import { LayoutGrid, List, ChevronLeft, ChevronRight } from "lucide-react";

// Shared page size for every document listing (list + folder view).
export const DOCS_PAGE_SIZE = 24;

const VIEW_KEY = "vs_docs_view";

// localStorage-backed view mode ("list" | "grid"), shared across every
// document listing so the user's preference is consistent app-wide.
export function useViewMode() {
  const [mode, setMode] = useState(() => {
    try {
      return localStorage.getItem(VIEW_KEY) === "grid" ? "grid" : "list";
    } catch {
      return "list";
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(VIEW_KEY, mode);
    } catch {}
  }, [mode]);
  return [mode, setMode];
}

// Segmented List / Folder switch (Google-Drive style).
export function ViewToggle({ mode, onChange }) {
  return (
    <div className="docs-viewtoggle" role="group" aria-label="View mode">
      <button
        type="button"
        className={mode === "list" ? "active" : ""}
        onClick={() => onChange("list")}
        title="List view"
        aria-pressed={mode === "list"}
      >
        <List size={15} />
      </button>
      <button
        type="button"
        className={mode === "grid" ? "active" : ""}
        onClick={() => onChange("grid")}
        title="Folder view"
        aria-pressed={mode === "grid"}
      >
        <LayoutGrid size={15} />
      </button>
    </div>
  );
}

// Numbered Prev / Next pager. Renders nothing when everything fits on one page.
export function Pager({ page, pageSize, total, onPage }) {
  const pages = Math.max(1, Math.ceil((total || 0) / pageSize));
  if (!total || total <= pageSize) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  return (
    <div className="docs-pager">
      <button
        className="docs-pager-btn"
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
        aria-label="Previous page"
      >
        <ChevronLeft size={16} /> Prev
      </button>
      <span className="docs-pager-info">
        {from}–{to} of {total} · Page {page} of {pages}
      </span>
      <button
        className="docs-pager-btn"
        disabled={page >= pages}
        onClick={() => onPage(page + 1)}
        aria-label="Next page"
      >
        Next <ChevronRight size={16} />
      </button>
    </div>
  );
}
